// On mobile, a file goes into FormData as { uri, type, name }. A browser would
// send that as the text "[object Object]". For files picked through the web
// image picker, swap in the real Blob so uploads work unchanged.
const blobs = new Map();

export const registerBlob = (uri, blob) => blobs.set(uri, blob);

const wrap = original =>
  function (name, value, ...rest) {
    if (
      value &&
      typeof value === 'object' &&
      !(value instanceof Blob) &&
      value.uri
    ) {
      const blob = blobs.get(value.uri);
      if (blob) {
        return original.call(this, name, blob, value.name || 'file');
      }
    }
    return original.call(this, name, value, ...rest);
  };

FormData.prototype.append = wrap(FormData.prototype.append);
FormData.prototype.set = wrap(FormData.prototype.set);
